module.exports = require("sketch/settings");